import { STATIC_PAGE_V2, ITEM_TYPES } from '../types/ItemTypes';
var WIX_DATA_PAGE_ITEM = ITEM_TYPES.WIX_DATA_PAGE_ITEM;
export function getUserPatternByItemType(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.userPatterns, userPatterns = _c === void 0 ? [] : _c, _d = _b.itemType, itemType = _d === void 0 ? STATIC_PAGE_V2 : _d, _e = _b.pageId, pageId = _e === void 0 ? '' : _e, _f = _b.options, _g = _f === void 0 ? {} : _f, _h = _g.logError, logError = _h === void 0 ? function () { } : _h;
    var userPatternContent;
    try {
        userPatternContent =
            (userPatterns.find(function (_a) {
                var patternType = _a.patternType;
                if (itemType === WIX_DATA_PAGE_ITEM) {
                    return patternType === "".concat(WIX_DATA_PAGE_ITEM, "-").concat(pageId);
                }
                return patternType === itemType;
            }) || {}).content || {};
        if (typeof userPatternContent === 'string') {
            return JSON.parse(userPatternContent);
        }
        return userPatternContent;
    }
    catch (error) {
        logError({ error: error, data: { value: userPatternContent } });
        return {};
    }
}
